import React, { useState, useEffect } from 'react';
import { getRol } from '../../../_utils/storage_handler';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Checkbox } from 'antd';
import { 
  findOrdersEvent
} from '../../../_events/orders/find_order.event';
import {  deleteOrdersEvent, displayPDFOrderEvent,sectionOrdersEvent } from '../../../_events/orders/order_box.event';
import { regroupEvent} from '../../../_events/orderDetail/orderDetail.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import InvoiceBoxList from './invoice_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import { 
  buildOrderBoxBody, 
  validateOrderBoxBody
} from '../../../_events/orders/order_box.input';
import { isNotViewer } from '../../../_utils/render_actions';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const InvoiceBox = () => {
  
  const in_process='FACT';

  const [allChecked, setAllChecked] = useState(false);
  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderDetail, setOrderDetail] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);

  const handleOpen = () => {         
      setOpen(true);                 
  };

  const handleClose = () => {
      setOpen(false);
  };

  const handleClosePDF = () => {
    setOpenPDF(false);
    setPDF(null);
  };

  const regroup =(orderDetail,order)=>{
    regroupEvent(orderDetail,order)
    .then((data) => {
      if(data.data!==undefined){
        message.warning(data.data);
      }else{
        message.success('Producto agrupado');
        loadOrders();
      }
    })
    .catch((error) => {
      console.error(error);
    });
    
  }
  const loadOrders = () => {
    setAllChecked(false);
    setLoading(false);
    findOrdersEvent('FACT')
    .then(data => {
      let orders_list = [];
      data.list.forEach(obj => {  
        if (obj.uuid != null && obj.id) {  
          orders_list.push(obj);
        } 
      });
      setOrders(orders_list);
      setLoading(false);
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  }

  const setEditOrder = (o, p) => {
    setOrder({uuid: p.uuid, order: o});
    setOrderDetail(o);
    handleOpen();
  }

  const aprove = () => {
  };
  

  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
    .then(data => {
      message.success('Orden eliminada');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  const section_product = (orderDetail,quantity_section,quantity_order,order) => {
    sectionOrdersEvent(orderDetail,quantity_section,quantity_order,order,in_process)
    .then(data => {
      message.success('Producto recortado.');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  const checkAll = () => {
    let check = allChecked;
    let ordersNew = [...orders];
    ordersNew.forEach(element => {
      element.checked = check ? 0 : 1;
    });
    setAllChecked(!check);
    setOrders(ordersNew);
  }

  const displayPDF = (order) => {
    if(! order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
      .then(data => {
        setPDF(data.data.toAproveJSON);
        setOpenPDF(true);     
      })
      .catch(err => {
        message.error(err.message);
      });
    }    
  }

  useEffect(() => {
    loadOrders();
  }, []);

  let rol = getRol();

  return (
    <Grid container spacing={1} >
        <Grid item xs={12} md={12}>
            <Typography variant="h6" component="h6">
                Bandeja de Facturados 
            </Typography>
            <hr />
            {
              loading ? (
                <PrimaryProgress />
              ) : (
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                      <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                      <Chip label={`Entregas INMEDIATAS: ${orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                      <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row-reverse', width: '100%'}}>
                      <BasicPopconfirm
                        label='Aprobar órdenes'
                        title='¿Seguro/a que deseas aprobar todas las órdenes seleccionadas?'
                        onConfirm={ () => { isNotViewer(rol) ? aprove() : alert('Usuario informativo')}}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row-reverse'}}>
                      <Checkbox
                        style={{marginRight:'55px'}} 
                        checked={allChecked}
                        onClick={event => {
                                event.stopPropagation();
                        }}
                        onChange={() => {
                            checkAll();
                        }}>
                      </Checkbox>
                    </div>                 
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <InvoiceBoxList
                      data={orders}
                      setEditOrder={(o, p) => setEditOrder(o, p)}
                      regroup={(orderDetail,o)=>regroup(orderDetail,o)}
                      updateDataOrdersChecked={(d) => {
                        let index = orders.findIndex(o => o.uuid === d.uuid);
                        if(index === -1){
                          message.error('No se logró seleccionar');
                        } else {
                          let orders_updated = [...orders];
                          orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                          setOrders(orders_updated);
                        }
                      }}
                      deleteOrder = {(o) => {isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo')}}
                      displayPDF = {(o) => displayPDF(o)}
                    />
                  </Grid>
                </Grid>
              )
            }
        </Grid>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
              <Grid container spacing={2}>  
                <Grid item xs={6} >
                  <TextField 
                    error={false}
                    required
                    style={{width: '100%'}} 
                    id="orderD_box_product" 
                    label="REF. PRODUCTO" 
                    variant="outlined"
                    size="small"
                    defaultValue={orderDetail ? orderDetail.productPrice.product.ref : ''}
                    disabled={true} 
                 />
                </Grid>
                <Grid item xs={6}>
                  <TextField 
                    error={false}
                    required
                    style={{width: '100%'}} 
                    id="orderD_box_color" 
                    label="COLOR" 
                    variant="outlined"
                    size="small"
                    defaultValue={orderDetail ? orderDetail.color.cod : ''}
                    disabled={true} 
                 />
                </Grid>
              </Grid>
              <br/>
              <Grid container spacing={2}>  
                <Grid item xs={6} >
                  <TextField 
                    error={false}
                    required
                    style={{width: '100%'}} 
                    id="orderD_box_quantity" 
                    label="MEDIDA ACTUAL" 
                    variant="outlined"
                    size="small"
                    defaultValue={orderDetail ? orderDetail.quantity : ''}
                    disabled={true} 
                 />
                </Grid>
                <Grid item xs={6}>
                  <TextField 
                    error={false}
                    required
                    style={{width: '100%'}} 
                    id="orderD_box_type_quantity" 
                    label="UNIDADES" 
                    variant="outlined"
                    size="small"
                    defaultValue={orderDetail ? orderDetail.type_quantity: ''}
                    disabled={true} 
                 />
                </Grid>
                <Grid item xs={6}>
                  <TextField 
                    error={false}
                    required
                    style={{width: '100%',display: 'none' }} 
                    id="orderD_box_price" 
                    label="PRECIO" 
                    variant="outlined"
                    size="small"
                    defaultValue={orderDetail ? orderDetail.price : ''}
                    disabled={true} 
                 />
                </Grid>
              </Grid>
            
              <Grid container spacing={1}>  
                <Grid item xs={12} md={12}>
                  <TextField 
                    error={false}
                    required
                    style={{width: '100%'}} 
                    id="orderD_box_section" 
                    label="MEDIDA DE CORTE" 
                    variant="outlined"
                    size="small"
                  />
                  
                  
                </Grid>
                <Grid item xs={12} md={12}>
                  <Button size='small' variant='contained' onClick={() => {
                      let index = orders.findIndex(o => o.uuid === order.uuid);
                      if(index === -1){
                        message.error('No se logró seleccionar');
                      } else {
                        let orders_updated = [...orders];
                        let odIndex = orders_updated[index].ordersDetail.findIndex(p => p.uuid === order.order.uuid);
                        if(odIndex === -1){
                          message.error('No se logró seleccionar detalle');
                        } else {
                          try{
                            let body = buildOrderBoxBody();
                            validateOrderBoxBody(body);                          
                            section_product(orderDetail,body.section,orderDetail.quantity,order);
                            handleClose();
                          } catch(err){
                            message.error(err.message);
                          }
                        }    
                      }
                    }}>Recortar</Button>
                </Grid>
              </Grid>
            </Box>
        </Modal>
        <Modal
            open={openPDF}
            onClose={handleClosePDF}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
              <Grid container spacing={1}>
                {
                  !pdf ? <>Cargando...</> :
                  <Grid item xs={12} md={12}>
                    <object width="100%" height="600px" 
                      data={`data:application/pdf;base64,${pdf}`} 
                      type="application/pdf" className="internal"
                    >
                      <embed 
                          src={`data:application/pdf;base64,${pdf}`}
                          type="application/pdf"
                      />
                    </object>
                  </Grid>
                }
              </Grid>
            </Box>
        </Modal>
    </Grid>
  );
}

export default InvoiceBox;
